import Vue from 'vue';
import api from './api/api';

export const initialLoad = null;

export const authModule = {
    state: () => ({
        JWT: null
    }),
    mutations: {
        mutateJWT(state, JWT) {
            state.JWT = JWT;
        },
    },
    actions: {
        // COMMITS
        commitJWT: ({ commit }, context) => new Promise((resolve, reject) => {
            commit('mutateJWT', context);
            resolve();
        }),

        // API CALLS
        dispatchLogin: ({ dispatch }, { username, password }) => new Promise((resolve, reject) => {
            api.login(username, password).then((response) => {
                const JWT = response.data.jwt;
                dispatch('commitJWT', JWT).then(() => resolve());
            }).catch((error) => {
                reject(error);
            });
        }),
    }
}

export const categoriesModule = {
    state: () => ({
        categoriesWithDetails: null, // list of categories with details
    }),
    mutations: {
        mutateCategoriesWithDetails(state, categories) {
            state.categoriesWithDetails = categories;
        },
    },
    actions: {
        // COMMITS
        commitCategoriesWithDetails: ({ commit }, context) => {
            commit('mutateCategoriesWithDetails', context);
        },

        // API CALLS
        dispatchCategoriesWithDetails: ({ dispatch }) => new Promise((resolve, reject) => {
            api.getCategoriesWithDetails().then((response) => {
                const { data } = response;
                console.log(response);
                dispatch('commitCategoriesWithDetails', data.categories);
                resolve();
            }).catch((error) => {
                reject(error);
            });
        }),
    }
}

export const areasModule = {
    state: () => ({}),
    mutations: {},
    actions: {}
}

export const locationsModule = {
    state: () => ({
        // Map data contans SVG coords and area names. Here because area names are also used in Admin.
        mapData: [
            {
                id: 'paijatHame',
                name: 'Päijät-Häme',
                shape: 'M596.967 2901.08L587.118 2888.44L597.173 2879.95L579.646 2858.64L587.058 2828.37L614.524 2812L612.337 2774.63L597.591 2763.24L586.057 2768.69L589.253 2756.72L564.58 2746.85L562.385 2694.25L571.013 2699.24L648.018 2692.01L663.592 2635.94L686.98 2625.21L699.389 2631.11L715.672 2602.96L733.83 2612.09L754.602 2644.09L783.902 2655.69L773.822 2682.53L770.352 2714.49L779.852 2721.25L780.562 2733.84L794.982 2747.35L803.612 2748.6L804.772 2764.17L795.512 2769.31L787.612 2790.04L766.572 2804.28L744.772 2804.21L741.072 2817.6L746.892 2830.19L751.272 2852.64L738.83 2851.88L733.432 2862.18L749.472 2869.06L741.732 2883.75L742.33 2900.7L755.902 2909.69L758.132 2925.4L762.422 2927.54L760.772 2941.44L747.562 2948.52L734.882 2937.14L714.99 2941.48L714.222 2927.73L700.882 2937.15L692.315 2935.74L664.175 2944.46L655.681 2936.5L648.68 2911.1L643.948 2906.88L628.113 2923.46L607.685 2898.62L596.967 2901.08Z',
                center: {
                    x: 200,
                    y: 200,
                },
                cities: [
                    {
                        x: 722,
                        y: 2871,
                        id: "lahti",
                        name: "Lahti"
                    }
                ]
            },
            {
                id: 'southOstrobothnia',
                name: 'South Ostrobothnia',
                shape: 'M93.252 2498.8L106.618 2511.04L139.956 2516.95L178.396 2484.26L190.171 2484.21L210.822 2452.51L226.369 2451.98L239.694 2424.79L258.007 2433.89L269.268 2433.98L298.036 2434.08L329.485 2416.91L343.822 2391.62L371.529 2402.44L375.402 2392.64L396.281 2395.62L422.029 2374.42L433.546 2381.75L436.489 2405.98L447.826 2410.69L468.112 2387.36L494.406 2391.17L500.489 2380L522.621 2379.66L528.307 2341.04L520.768 2330.74L526.283 2322.89L503.891 2261.87L512.931 2254.79L499.769 2237.13L495.061 2198.95L505.426 2184.54L475.996 2170.63L488.987 2165.27L463.695 2133.31L439.116 2125.93L411.896 2090.13L397.72 2072.77L380.182 2064.33L356.235 2064L347.158 2090.63L335.156 2101.17L317.854 2096.19L285.069 2101.96L253.949 2117.12L253.588 2141.5L261.585 2141.77L267.947 2169.7L251.637 2169.5L217.428 2228.79L219.943 2245.77L190.519 2276.7L153.869 2264.51L130.406 2240.03L123.767 2247.78L120.239 2284.19L127.698 2291.72L103.422 2318.05L84 2375.49L91.633 2394.35L102.61 2397.97L103.179 2426.22L109.809 2429.07L117.008 2439.57L101.9 2449.21L104.696 2463.63L96.489 2470.12L93.252 2498.8Z',
                center: {
                    x: 200,
                    y: 200
                },
                cities: [
                    {
                        x: 269,
                        y: 2289,
                        id: "seinajoki",
                        name: "Seinäjoki"
                    }
                ]
            },
            {
                id: 'kantaHame',
                name: 'Kanta-Häme',
                shape: 'M565.761 2749.52L548.182 2757.39L536.414 2745.63L530.998 2757.87L506.207 2748.23L477.662 2770.61L472.893 2767L469.44 2772.42L469.812 2778.9L473.129 2782.81L464.31 2793.31L395.525 2819.41L399.748 2851.79L394.634 2856.8L374.16 2834.43L344.248 2845.83L329.786 2846.05L327.506 2836.05L313.243 2825.23L302.957 2831.53L302.745 2839.79L314.936 2847.08L306.786 2866.08L292.22 2869.05L290.828 2882.96L299.068 2892.59L292.264 2898.68L293.025 2910.61L318.357 2923.61L337.547 2914.03L373.01 2941.25L404.447 2951.66L450.093 2959.52L455.723 2971.99L466.531 2963.71L477.646 2969.01L480.366 2979.37L508.286 2973.88L507.07 2959.54L514.925 2948.96L532.486 2951.57L572.276 2943.35L588.646 2949.02L599.011 2930.11L588.13 2926.41L598.152 2903.73L588.299 2891.11L598.354 2882.62L580.827 2861.31L588.239 2831.04L615.705 2814.67L613.518 2777.3L598.772 2765.91L587.238 2771.36L590.434 2759.39L565.761 2749.52Z',
                center: {
                    x: 200,
                    y: 200
                },
                cities: [
                    {
                        x: 505,
                        y: 2821,
                        id: "hameenlinna",
                        name: "Hämeenlinna"
                    }
                ]
            },
            {
                id: 'southKarelia',
                name: 'South Karelia',
                shape: 'M1038.24 2956.64L1020.28 2947.46L1012.44 2928.17L996.213 2925.76L988.921 2910.98L967.273 2911.51L948.153 2901.33L941.261 2889.23L915.703 2881.77L908.051 2868.7L916.043 2863.93L901.613 2846.32L906.713 2829.11L922.591 2823.2L912.443 2800.16L933.873 2795.01L926.873 2780.79L932.953 2769L915.131 2749.93L896.953 2752.58L878.163 2741.33L884.653 2731.39L899.932 2732.66L903.643 2725.67L941.511 2725.85L965.341 2740.15L986.483 2731.48L1019.52 2738.27L1069.07 2733.95L1094.38 2702.64L1101.93 2683.93L1116.12 2694.76L1153.43 2694.53L1158.25 2677.59L1188.7 2678.96L1219.4 2669.13L1238.36 2637.65L1262.53 2629.47L1268.16 2613.44L1357.48 2565.48L1354.58 2568.44L1342.64 2602.22L1312.64 2629.84L1292.46 2672.2L1267.04 2690.21L1261.3 2707.97L1223.56 2771.6L1179.39 2802.25L1163.59 2808.68L1144.62 2841.17L1142.22 2862.47L1121.81 2867.02L1083.57 2900.49L1076.23 2920.11L1038.24 2956.64Z',
                center: {
                    x: 200,
                    y: 200
                },
                cities: [
                    {
                        x: 1062,
                        y: 2811,
                        id: "lappeenranta",
                        name: "Lappeenranta"
                    }
                ]
            },
            {
                id: 'kymenlaakso',
                name: 'Kymenlaakso',
                shape: 'M802.213 3021.56L803.613 2998.49L824.313 2976.79L837.761 2976.47L831.573 2960.08L821.033 2959.41L814.801 2971.46L801.193 2970.16L795.913 2957.14L786.373 2956.84L778.403 2936.71L762.153 2928.91L758.313 2927.07L756.083 2911.36L742.511 2902.37L741.913 2885.42L749.653 2870.73L733.613 2863.85L739.011 2853.55L751.453 2854.31L747.073 2831.86L741.253 2819.27L744.953 2805.88L766.753 2805.95L787.793 2791.71L795.693 2770.98L804.953 2765.84L815.773 2761.48L831.841 2786.97L846.913 2779.19L847.171 2763.63L867.293 2764.05L867.353 2790.8L895.261 2804.64L911.463 2799.2L921.591 2822.2L905.713 2828.11L900.613 2845.32L915.043 2862.93L907.051 2867.7L914.703 2880.77L940.261 2888.23L947.153 2900.33L966.273 2910.51L987.921 2909.98L995.213 2924.76L1011.44 2927.17L1019.28 2946.46L1037.24 2955.64L1021.43 2970.85L1020.94 2980.98L1010.6 2987.82L998.551 2979.93L993.743 2983.62L989.993 3000.45L984.682 3009.13L976.653 3009.38L966.921 3010.79L960.551 3007.27L954.703 3011.2L947.653 3017.83L938.603 3004.41L915.131 3001.65L886.671 2992.35L875.153 3003.93L875.493 3022.5L871.341 3029.95L859.671 3029.59L846.283 3016.23L838.463 3023.35L828.453 3023.7L822.193 3017.09L815.563 3021.69L802.213 3021.56Z',
                center: {
                    x: 200,
                    y: 200
                },
                cities: [
                    {
                        x: 862,
                        y: 2976,
                        id: "kotka",
                        name: "Kotka"
                    }
                ]
            },
            {
                id: 'uusimaa',
                name: 'Uusimaa',
                shape: 'M606.527 3082.47L612.221 3080.91L614.42 3074.2L621.559 3072.24L645.928 3071.61L652.083 3064.07L652.446 3050.8L668.446 3049L672.421 3063.64L685.104 3079.32L690.128 3080.27L697.585 3072.27L705.834 3077.39L710.105 3071.9L705.422 3056.97L709.62 3053.57L718.014 3070.76L723.139 3068.73L722.205 3056.22L727.167 3054.5L734.797 3058.27L740.415 3055.83L731.016 3039.27L728.375 3028.74L718.808 3015.89L720.173 3007.79L735.772 3022.61L746.706 3033.81L751.861 3045.26L757.939 3044.78L763.188 3036.33L762.082 3021.7L772.071 3021.14L777.285 3032.36L784.774 3032.63L800.964 3016.8H801.758L803.105 2993.58L823.908 2971.88L837.423 2971.56L831.204 2955.17L820.612 2954.5L814.349 2966.55L800.673 2965.25L795.367 2952.23L785.779 2951.93L777.77 2931.8L761.696 2924.12L761.7 2924.08L761.439 2924L761.696 2924.12L760.233 2938.2L746.957 2945.28L734.214 2933.9L714.223 2938.24L713.451 2924.49L700.045 2933.91L691.435 2932.5L663.155 2941.22L658.661 2937.03L651.942 2912.77L647.186 2908.55L631.273 2925.13L610.743 2900.29L599.976 2902.73L589.904 2925.41L600.839 2929.11L590.422 2948.02L573.971 2942.35L533.983 2950.57L516.335 2947.96L508.441 2958.54L509.663 2972.88L481.604 2978.37L478.87 2968.01L467.7 2962.71L456.838 2970.99L451.18 2958.52L405.307 2950.66L400.412 2957.63L405.946 2967.07L394.831 2991.82L371.531 2995L370.203 3008.77L380.419 3012.9L383.626 3032.11L373.725 3033.15L370.762 3052.9L355.785 3058.03L356.891 3092.19L340.796 3084.69L312.042 3098.9L302.373 3091.25L283.467 3110.94L258.355 3111.41L258.356 3111.4L258.088 3111.42L258.355 3111.41L254.182 3146.83L245.072 3142.15L233.796 3142.64L231.383 3154.39L241.151 3167.23L258.961 3170.32L263.722 3165.7L264.142 3149.88L269.778 3145.36L274.565 3152.73L271.968 3172.01L266.332 3178.77L238.555 3188.52L232.047 3195.82L239 3204.56L259.824 3195.95L284.99 3196.15L298 3185.09L298.001 3177.91L307.977 3166.91L320.115 3168.47L327.941 3174.02L343.98 3170.61L356.582 3173.33L363.061 3168.4L360.501 3159.09L378.692 3157.43L415.561 3141.71L445.938 3141.05L468.116 3128.85L467.19 3148.01L471.944 3148.06L478.91 3142.02L484.958 3145.5L471.956 3162.47L481.514 3163.21L511.02 3126.32L510.981 3116.43L513.14 3111.31L518.376 3116.53L545.267 3107.13L555.361 3113.98L569.552 3114.18L574.342 3106.62L576.467 3118.28L587.329 3109.14L585.627 3096.6L596.479 3099.94L604.263 3089.43L606.527 3082.47Z',
                center: {
                    x: 200,
                    y: 200
                },
                cities: [
                    {
                        x: 547,
                        y: 3104,
                        id: "helsinki",
                        name: "Helsinki"
                    }
                ]
            },
            {
                id: 'lapland',
                name: 'Lapland',
                shape: 'M630.282 1408.24L629.679 1408.8L644.652 1393.61L665.924 1382.57L669.111 1367.81L722.463 1370.86L768.932 1341.59L772.432 1371.57L864.273 1379.52L895.413 1368.91L937.873 1299.73L951.421 1305.9L961.723 1301.02L975.573 1335.4L1042.99 1346.06L1072.79 1333.04L1073.92 1314.02L1059.19 1291.82L1077.52 1282.95L1095.63 1288.09L1101.1 1283.64L1100.74 1266.85L1088.21 1257.72L1088.53 1240.38L1097.9 1238.92L1102.44 1207.65L1083.99 1199.89L1071.35 1172.69L1076.23 1154.36L1091.21 1148.43L1090.72 1131.8L1164.96 1149.21L1210.19 1143.4L1198.22 1111.35L1133.77 1002.52L1141.22 977.949L1239.31 793.984L1243.02 748.958L1196.89 714.44L1149.62 617.936L1077.34 588.533L1052.88 486.55L1081.67 434.654L1088.14 388.178L1080.01 374.404L1047.23 374.519L1101.14 329.162L1090.84 293.058L1094.33 259.346L1146.18 191.971L1116.89 117.281L1029.64 74.29L1027.61 55.336L1000.91 38.538L973.243 0L957.643 9.832L942.223 4.829L931.533 20.354L888.783 54.249L839.421 41.39L811.043 51.337L793.733 92.55L764.523 118.541L750.153 141.576L755.671 157.545L746.283 174.645L727.983 279.325L731.682 341.478L721.703 376.472L701.37 371.263L682.924 382.347L657.78 419.332L660.595 455.078L643.339 454.97L637.17 467.57L613.042 437.865L569.411 418.779L528.197 388.245L507.354 399.187L496.316 418.652L468.773 428.382L439.609 441.525L432.669 427.173L400.598 423.845L369.929 401.641L352.219 409.09L354.257 374.685L284.25 232.752L242.865 218.376L217.094 231.053L199.819 251.698L209.963 278.487L204.762 296.586L172.109 271.3L148.973 293.938L178.634 332.296L180.397 358.623L203.119 364.75L235.682 432.353L259.437 439.731L268.164 461.649L290.367 472.513L299.374 498.564L331.9 505.98L375.208 525.837L422.248 569.182L422.334 598.068L428.536 615.063L442.884 613.048L448.87 641.548L475.298 669.063L464.301 682.135L455.601 696.799L455.201 715.255L456.391 771.964L441.326 810.689L452.949 831.614L480.514 836.368L473.486 852.237L478.813 870.496L455.093 882.825L453.997 914.274L501.495 1024.04L483.997 1043.38L480.588 1099.58L462.899 1114.92L458.161 1130.38L452.171 1148.9L456.341 1165.64L451.742 1177.59L459.587 1216.52L479.754 1236.08L480.833 1256.68L497.616 1284.07L499.095 1303.82L509.246 1331.16L509.504 1353.13L520.584 1351.85L528.329 1339.51L538.005 1351.13L558.895 1358.86L565.418 1368.52L558.079 1383.92L563.368 1390.04L573.508 1383.42L577.448 1396.12L585.695 1395.28L592.676 1389.58L606.59 1391.65L614.878 1402.37L623.752 1401.55L630.282 1408.24Z',
                center: {
                    x: 200,
                    y: 200
                },
                cities: [
                    {
                        x: 665,
                        y: 1126,
                        id: "rovaniemi",
                        name: "Rovaniemi"
                    }
                ]
            },
            {
                id: 'northKarelia',
                name: 'North Karelia',
                shape: 'M1066.19 1985.69L1085.74 2007.45L1101.19 2008.62L1105.13 2040.53L1113.8 2047.57L1107.21 2057.2L1111.13 2093.9L1126.37 2102.89L1126.74 2124.49L1113.17 2149.31L1124.05 2159.07L1147.21 2207.73L1179.61 2224.43L1157.93 2240.16L1175.53 2263.93L1157.01 2289.38L1132.16 2278.55L1128.13 2290.67L1115.11 2294.13L1132.91 2333.4L1145.07 2337.14L1172.87 2362.69L1174.77 2373.26L1189.07 2385.32L1183.04 2399.6L1197.05 2409.63L1211.19 2401.01L1219.59 2411.34L1219.6 2427.97L1238.29 2458.46L1249.38 2519.22L1268.57 2527.61L1276.27 2545.25L1269.93 2553.24L1281.19 2576.09L1268.49 2612.93L1358.03 2564.49L1375.75 2546.15L1415.64 2476.29L1444.36 2432.28L1463.26 2424.89L1498.33 2359.66L1539.84 2228L1527.73 2197.43L1492.73 2168.97L1481.15 2129.14L1456.21 2111.92L1424.47 2086.91L1379.69 2066.58L1361.66 2041.12L1308.84 1984.74L1283.79 1982.48L1270.28 1997.2L1249.49 1944.31L1149.25 1962.2L1081.89 1949.75L1066.19 1985.69Z',
                center: {
                    x: 200,
                    y: 200
                },
                cities: [
                    {
                        x: 1447,
                        y: 2334,
                        id: "joensuu",
                        name: "Joensuu"
                    }
                ]
            },
            {
                id: 'southSavo',
                name: 'South Savo',
                shape: 'M842.533 2400.27L832.033 2407.55L848.591 2425.83L833.932 2431.02L825.273 2467.77L807.682 2458.83L783.213 2474.01L769.403 2502.2L791.543 2542.83L785.043 2552.63L790.193 2606.63L811.381 2637.84L806.163 2657.1L787.483 2651.13L784.853 2658.18L774.873 2684.88L771.403 2716.82L780.903 2723.56L781.613 2736.15L796.033 2749.65L804.663 2750.9L805.823 2766.45L816.643 2762.1L832.713 2787.57L847.783 2779.8L848.043 2764.25L868.163 2764.66L868.223 2791.4L896.131 2805.23L912.313 2799.75L933.743 2794.6L926.743 2780.39L932.823 2768.61L915.003 2749.56L896.823 2752.2L878.033 2740.96L884.523 2731.04L899.801 2732.3L903.511 2725.32L941.381 2725.5L965.213 2739.79L986.353 2731.12L1019.39 2737.91L1068.94 2733.59L1094.25 2702.31L1101.8 2683.61L1115.99 2694.43L1153.3 2694.2L1158.12 2677.27L1188.57 2678.64L1219.27 2668.82L1238.23 2637.36L1262.4 2629.19L1268.03 2613.17L1268.49 2612.93L1281.19 2576.09L1269.93 2553.24L1276.27 2545.25L1268.57 2527.61L1249.38 2519.22L1238.29 2458.46L1219.6 2427.97L1219.59 2411.34L1211.19 2401.01L1197.05 2409.63L1183.04 2399.6L1189.07 2385.32L1174.77 2373.26L1172.87 2362.69L1145.07 2337.14L1132.91 2333.4L1122.9 2336.32L1096.94 2361.96L1083.29 2361.97L1083.33 2391.29L1071.47 2389.82L1062.09 2405.37L1072.9 2413.57L1066.67 2426.33L1084.34 2425.64L1085.58 2440.64L1102.18 2436.58L1125.05 2465.06L1117.82 2482.78L1072.03 2464.92L1043.57 2468.17L1026.2 2452.85L1000.7 2451.34L986.011 2425.71L935.091 2381.43L910.643 2397.99L900.083 2384.58L878.733 2389.9L873.213 2398.19L858.341 2391.7L842.533 2400.27Z',
                center: {
                    x: 200,
                    y: 200
                },
                cities: [
                    {
                        x: 887,
                        y: 2654,
                        id: "mikkeli",
                        name: "Mikkeli"
                    }
                ]
            },
            {
                id: 'northSavo',
                name: 'North Savo',
                shape: 'M1083.29 2361.97L1096.94 2361.96L1122.9 2336.32L1132.91 2333.4L1115.11 2294.13L1128.13 2290.67L1132.16 2278.55L1157.01 2289.38L1175.53 2263.93L1157.93 2240.16L1179.61 2224.43L1147.21 2207.73L1124.05 2159.07L1113.17 2149.31L1126.74 2124.49L1126.37 2102.89L1111.13 2093.9L1107.21 2057.2L1113.8 2047.57L1105.13 2040.53L1101.19 2008.62L1085.74 2007.45L1066.19 1985.69L1055.28 2011.01L1015.15 1964.72L953.503 1925.26L902.421 1921.37L859.253 1905.02L824.853 1916.61L775.123 1962.64L782.563 2038.17L774.293 2043.13L758.163 2088.78L751.123 2114.72L761.723 2129.17L765.063 2182.18L785.523 2210.35L773.341 2218.49L782.983 2228.03L774.963 2241.54L745.653 2245.35L787.373 2297.51L799.663 2294.48L817.413 2321.58L822.301 2350.26L802.723 2371.21L802.761 2379.7L825.051 2393.97L835.881 2392.58L842.533 2400.27L858.341 2391.7L873.213 2398.19L878.733 2389.9L900.083 2384.58L910.643 2397.99L935.091 2381.43L986.011 2425.71L1000.7 2451.34L1026.2 2452.85L1043.57 2468.17L1072.03 2464.92L1117.82 2482.78L1125.05 2465.06L1102.18 2436.58L1085.58 2440.64L1084.34 2425.64L1066.67 2426.33L1072.9 2413.57L1062.09 2405.37L1071.47 2389.82L1083.33 2391.29L1083.29 2361.97Z',
                center: {
                    x: 200,
                    y: 200
                },
                cities: [
                    {
                        x: 1042,
                        y: 2236,
                        id: "kuopio",
                        name: "Kuopio"
                    }
                ]
            },
            {
                id: 'kainuu',
                name: 'Kainuu',
                shape: 'M859.253 1905.02L902.421 1921.37L953.503 1925.26L1015.15 1964.72L1055.32 2011.06L1082.02 1949.54L1149.38 1962L1249.62 1944.1L1270.41 1997.02L1283.92 1982.29L1309.1 1984.54L1307.31 1982.78L1339.55 1959.79L1373.68 1870.72L1363.1 1821.51L1309.01 1784.41L1293.57 1742.87L1293.48 1720.15L1304.48 1710.49L1305.13 1690.47L1294.55 1677.23L1299 1661.28L1248.6 1650.93L1233.77 1593.87L1239.13 1573.8L1258.37 1567.39L1265.96 1551.67L1258.97 1542.39L1267.5 1524.89L1259.36 1515.47L1233.25 1513.06L1244.17 1476.11L1246.32 1443.71L1249.75 1432.17L1212.89 1439.82L1177.94 1438.17L1171.91 1433.17L1159.48 1459.81L1144.71 1464.25L1136.02 1457.16L1095.13 1476.46L1091.76 1510.01L1019.5 1522.98L1004.62 1532.04L998.511 1569.55L984.313 1559.75L968.171 1557.64L953.682 1568.45L925.813 1568.33L913.123 1589.18L930.253 1603.51L932.713 1644.36L927.003 1659.75L896.563 1652.74L895.723 1660.12L869.833 1672.46L859.823 1701.49L831.463 1715.32L826.543 1731.25L813.333 1735.12L788.283 1760.69L801.493 1769.36L808.893 1785.74L806.623 1799.91L821.103 1812.6L832.823 1810.98L848.421 1821.35L848.413 1891.39L859.253 1905.02Z',
                center: {
                    x: 200,
                    y: 200
                },
                cities: [
                    {
                        x: 935,
                        y: 1846,
                        id: "kajaani",
                        name: "Kajaani"
                    }
                ]
            },
            {
                id: 'centralFinland',
                name: 'Central Finland',
                shape: 'M447.838 2410.3L447.94 2438.44L469.296 2451.21L480.506 2449.1L488.219 2471.13L508.756 2475.21L521.571 2470.61L543.964 2494.39L551.091 2520.54L536.711 2543.53L532.433 2535.92L519.039 2555.33L553.114 2597.9L560.129 2599.13L560.045 2605.51L552.868 2605.96L550.682 2599.86L545.179 2603.54L548.04 2613.26L546.918 2625.29L554.464 2629.82L556.886 2628.45L566.819 2634.36L557.134 2641.13L552.848 2650.57L554.997 2663.35L573.382 2678.52L572.194 2701.91L649.199 2694.68L664.773 2638.61L688.161 2627.88L700.57 2633.78L716.853 2605.63L735.011 2614.76L755.783 2646.76L784.983 2658.48L787.613 2651.43L806.293 2657.41L811.511 2638.13L790.323 2606.89L785.171 2552.85L791.671 2543.05L769.533 2502.39L783.341 2474.18L807.813 2458.98L825.403 2467.93L834.063 2431.16L848.723 2425.97L832.163 2407.67L842.663 2400.39L836.011 2392.69L825.182 2394.09L802.893 2379.8L802.853 2371.31L822.432 2350.34L817.543 2321.64L799.793 2294.52L787.503 2297.55L745.783 2245.36L775.091 2241.54L783.113 2228.02L773.473 2218.48L785.653 2210.33L765.193 2182.14L761.723 2129.17L751.253 2114.63L758.163 2088.78L727.301 2089L718.393 2070.18L708.903 2062.27L685.322 2062.2L638.656 2030.18L623.935 2036.3L617.46 2076.53L599.444 2078.57L587.197 2080.66L563.197 2106.23L560.655 2175.68L537.754 2170.69L511.483 2180.38L505.329 2184.42L495.243 2198.62L499.951 2236.8L513.113 2254.46L504.073 2261.54L526.465 2322.56L520.95 2330.41L528.489 2340.71L522.803 2379.33L500.671 2379.67L494.588 2390.84L468.294 2387.03L447.838 2410.3Z',
                center: {
                    x: 200,
                    y: 200
                },
                cities: [
                    {
                        x: 682,
                        y: 2461,
                        id: "jyvaskyla",
                        name: "Jyväskylä"
                    }
                ]
            },
            {
                id: 'ostrobothnia',
                name: 'Ostrobothnia',
                shape: 'M412.078 2089.8L419.922 2064.45L399.504 2027.4L391.088 2029.79L382.018 2013.76L395.757 2004.87L406.514 2013.64L423.775 2013.24L432.148 2004.27L395.373 1974.7L384.75 1982.94L378.702 1973.94L355.611 1985.2L322.917 1960.79L316.695 1969.22L302.586 1930.27L293.443 1943.95L283.575 1950.48L286.323 1966.58L284.761 1978.37L272.701 1986.07L270.868 1994.73L264.201 1997.61L254.624 2005.86L253.618 2010.73L244.649 2017.28L240.878 2033.79L234.324 2025.19L227.504 2028.93L222.552 2050.38L214.954 2050.83L210.999 2056.07L213.386 2063.81L218.889 2069.34L230.964 2096.44L226.549 2107.17L215.485 2107.39L207.379 2122.77L194.439 2125.8L159.876 2113.41L135.27 2123.77L123.802 2124.02L118.966 2109.57L110.938 2117.72L110.171 2139.39L101.784 2149.81L103.011 2157.66L112.909 2166.28L116.036 2174.02L110.905 2176.01L101.767 2173.58L95.4467 2175.64L85.4937 2169.03L80.8538 2176.57L91.3188 2184.55L95.7838 2194.15L94.7238 2205.88L84.2418 2215.83L85.5468 2226.21L81.2798 2230.57L70.0348 2231.85L69.3228 2226.35L58.3687 2230.12L55.3918 2248.18L49.6898 2254.28L38.4067 2253.69L37.2127 2258.51L43.9048 2266.13L42.9377 2274.81L36.5537 2280.6L31.6537 2286.35L28.4277 2306.9L32.2467 2311.5L39.0317 2305.79L44.1997 2309.66L45.2148 2316.17L35.3488 2332.3L33.1517 2350.94L37.7578 2355.83L31.7787 2379.65L38.2227 2389.64L59.8968 2390.71L59.2508 2397.79L49.0778 2411.35L49.1147 2422.61L64.0338 2428.44L65.6068 2436.51L53.7188 2449.22L54.1768 2460.45L46.4688 2473.07L39.2578 2500.45L47.0898 2513.45L47.7387 2515.85L62.8677 2502.06L93.4337 2498.47L96.6707 2469.79L104.878 2463.3L102.082 2448.88L117.19 2439.24L109.991 2428.74L103.361 2425.89L102.792 2397.64L91.8148 2394.02L84.1818 2375.16L103.604 2317.72L127.88 2291.39L120.421 2283.86L123.949 2247.45L130.588 2239.7L154.051 2264.18L190.701 2276.37L220.125 2245.44L217.61 2228.46L251.819 2169.17L268.129 2169.37L261.767 2141.44L253.77 2141.17L254.131 2116.79L285.251 2101.63L318.036 2095.86L335.338 2100.84L347.34 2090.3L356.417 2063.67L380.364 2064L397.902 2072.44L412.078 2089.8Z',
                center: {
                    x: 200,
                    y: 200
                },
                cities: [
                    {
                        x: 147,
                        y: 2169,
                        id: "vaasa",
                        name: "Vaasa"
                    }
                ]
            },
            {
                id: 'satakunta',
                name: 'Satakunta',
                shape: 'M29.9658 2745.66L35.8138 2749.33L36.7007 2753.43L37.3488 2756.43L33.4628 2761.62L29.4717 2761.93L27.8508 2762.05L25.2188 2752.09L26.6608 2749.33L29.9658 2745.66ZM51.1218 2604.82L56.0168 2606.21L61.6938 2616.62L65.8427 2624.23L61.1588 2629.44L54.0518 2629.42L51.1648 2629.41L44.2567 2622.07L49.3978 2616.86L51.1218 2604.82ZM31.5608 2792.55L38.4178 2778.78L45.7588 2736.88L53.2848 2741.89L57.0988 2737.05L56.3087 2730.46L61.0268 2706.07L50.7638 2682.02L52.7018 2679L57.3928 2677.46L64.4138 2680.21L69.8198 2679.22L66.1858 2670.34L54.9578 2664.42L54.0847 2656.5L61.6478 2656.8L73.5648 2660.31L73.2258 2655.83L66.6418 2650.51L59.5757 2636.16L62.5578 2630.5L68.1407 2630.9L77.0168 2641.02L83.6768 2641.25L70.7747 2612.28L70.7867 2586L57.3888 2568.65L60.0797 2562.71L67.9258 2561.88L68.4348 2557.22L62.4157 2552.54L58.7177 2528.96L49.7928 2523.48L47.7357 2515.85L62.8647 2502.06L93.4308 2498.47L106.798 2510.71L140.137 2516.62L178.575 2483.93L190.349 2483.88L211 2452.18L226.547 2451.65L239.871 2424.47L258.184 2433.56L269.574 2433.51L269.585 2463.79L254.073 2471.28L253.196 2497.4L235.102 2499.16L225.914 2514.54L239.721 2521.32L239.737 2535.05L255.124 2546.57L261.247 2568.3L252.583 2598.58L239.518 2594.33L235.065 2617.38L246.249 2628.16L232.458 2639.8L223.106 2668.63L242.482 2682.19L239.839 2695.24L215.521 2698.81L206.299 2705.8L207.195 2719.18L220.268 2751.13L246.415 2759.81L254.971 2750.5L269.913 2765.76L263.084 2789.72L275.398 2811L265.289 2812.59L249.732 2807.37L247.716 2834.31L222.776 2827.48L199.266 2834.62L204.415 2841.11L177.976 2848.12L159.048 2844.57L143.223 2858.8L137.667 2850.62L110.808 2848.02L100.359 2818.63L88.8907 2808.28L67.9328 2823.42L66.8458 2797.54L53.8228 2807.35L42.6657 2808.21L31.5608 2792.55Z',
                center: {
                    x: 200,
                    y: 200
                },
                cities: [
                    {
                        x: 97,
                        y: 2644,
                        id: "pori",
                        name: "Pori"
                    }
                ]
            },
            {
                id: 'southwestFinland',
                name: 'Southwest Finland',
                shape: 'M302.854 2832.03L295.026 2833.04L296.372 2822.57L276.985 2826.35L265.295 2812.59L249.738 2807.37L247.723 2834.31L222.782 2827.48L199.273 2834.61L204.421 2841.1L177.982 2848.12L159.054 2844.56L143.23 2858.8L137.673 2850.62L110.815 2848.02L100.365 2818.63L88.897 2808.28L67.939 2823.42L66.853 2797.54L53.829 2807.35L42.671 2808.21L31.457 2792.4L26.949 2785.74L18.665 2790.36L22.998 2814.15L33.919 2825.48L31.669 2833.2L24.844 2827.8L18.4 2814.84L11.089 2815.32L7.26999 2819.32L13.757 2826.26L13.302 2834.07L0 2836.75L0.854004 2842.4L16.035 2851.6L14.463 2856.65L11.248 2858.85L9.40799 2864.25L11.826 2873.4L12.362 2886.52L17.456 2894.6L17.134 2912.57L28.116 2941.36L42.392 2953.91L46.739 2972.55L57.892 2971.55L62.848 2950.07L82.998 2939.26L89.763 2942.3L82.879 2960.07L74.988 2959.31L67.73 2969.51L66.967 2977.49L83.578 2973.43L104.852 2972.77L112.861 2980.51L112.465 2988.42L105.032 2988.05L101.825 2992.03L112.716 3001.97L121.55 2996.28L125.041 2999.02L123.369 3019.99L131.394 3020.5L141.301 3029.9L178.965 3022.64L184.561 3017.79L193.524 3024.61L178.804 3048.13L178.843 3057.76L194.533 3057.38L204.371 3066.28L227.279 3059.53L262.714 3032.14L268.296 3041.44L259.812 3051.78L238.928 3077.23L242.915 3098.32L249.606 3102.35L258.754 3107.86L258.223 3112.4L283.209 3111.94L302.022 3092.25L311.643 3099.9L340.255 3085.69L356.27 3093.19L355.17 3059.03L370.072 3053.9L373.021 3034.15L382.873 3033.11L379.682 3013.9L369.516 3009.77L370.838 2996L394.022 2992.82L405.082 2968.07L399.576 2958.63L404.447 2951.66L373.01 2941.25L337.547 2914.03L318.357 2923.61L293.025 2910.61L292.264 2898.68L299.068 2892.59L290.828 2882.96L292.22 2869.05L306.786 2866.08L314.936 2847.08L302.745 2839.79L302.854 2832.03Z',
                center: {
                    x: 200,
                    y: 200
                },
                cities: [
                    {
                        x: 137,
                        y: 2976,
                        id: "turku",
                        name: "Turku"
                    }
                ]
            },
            {
                id: 'centralOstrobothnia',
                name: 'Central Ostrobothnia',
                shape: 'M599.445 2078.57L538.116 2003.52L521.671 1954.08L506.917 1948.27L501.934 1927.32L491.145 1921.7L481.721 1884.08L423.652 1845.8L413.982 1860.53L412.779 1884.03L403.293 1885.68L391.469 1874.39L383.48 1880.09L382.427 1925.83L334.621 1927.99L328.772 1936.54L322.178 1936.68L316.209 1929.49L303.156 1929.42C302.826 1929.91 302.753 1929.46 302.424 1929.95L316.697 1969.21L322.919 1960.78L355.612 1985.2L378.704 1973.94L384.752 1982.93L395.374 1974.7L432.149 2004.26L423.777 2013.24L406.514 2013.64L395.76 2004.87L382.019 2013.76L391.088 2029.79L399.504 2027.39L419.924 2064.45L412.128 2090.47L439.3 2125.6L463.877 2132.98L489.169 2164.94L476.18 2170.3L505.61 2184.22L511.485 2180.38L537.756 2170.69L560.656 2175.68L563.197 2106.23L587.197 2080.66L599.445 2078.57Z',
                center: {
                    x: 200,
                    y: 200
                },
                cities: [
                    {
                        x: 357,
                        y: 1946,
                        id: "kokkola",
                        name: "Kokkola"
                    }
                ]
            },
            {
                id: 'pirkanmaa',
                name: 'Pirkanmaa',
                shape: 'M448.008 2410.36L436.671 2405.65L433.728 2381.42L422.211 2374.09L396.463 2395.29L375.584 2392.31L371.711 2402.11L344.004 2391.29L329.667 2416.58L298.218 2433.75L269.579 2433.51L269.588 2463.79L254.078 2471.27L253.201 2497.4L235.107 2499.15L225.92 2514.54L239.726 2521.32L239.741 2535.05L255.129 2546.56L261.252 2568.3L252.587 2598.58L239.521 2594.33L235.068 2617.38L246.251 2628.16L232.461 2639.8L223.109 2668.63L242.485 2682.18L239.841 2695.24L215.524 2698.8L206.301 2705.8L207.2 2719.18L220.273 2751.13L246.421 2759.81L254.977 2750.5L269.92 2765.75L263.088 2789.72L275.404 2811L265.295 2812.59L276.985 2826.35L296.372 2822.57L295.026 2833.04L302.957 2831.53L313.243 2825.23L327.506 2836.05L329.786 2846.05L344.248 2845.83L374.16 2834.43L394.634 2856.8L399.748 2851.79L395.525 2819.41L464.31 2793.31L473.129 2782.81L469.812 2778.9L469.44 2772.42L472.893 2767L477.662 2770.61L506.207 2748.23L530.998 2757.87L536.414 2745.63L548.182 2757.39L565.761 2749.52L563.566 2696.92L572.194 2701.91L573.382 2678.52L554.997 2663.35L552.848 2650.57L557.134 2641.13L566.819 2634.36L556.886 2628.45L554.464 2629.82L546.918 2625.29L548.04 2613.25L545.179 2603.54L550.682 2599.86L552.868 2605.96L560.045 2605.51L560.129 2599.13L553.114 2597.9L519.039 2555.33L532.433 2535.92L536.711 2543.53L551.091 2520.54L543.964 2494.39L521.571 2470.61L508.756 2475.21L488.219 2471.13L480.506 2449.1L469.296 2451.21L447.94 2438.44L448.008 2410.36Z',
                center: {
                    x: 200,
                    y: 200
                },
                cities: [
                    {
                        x: 374,
                        y: 2636,
                        id: "tampere",
                        name: "Tampere"
                    }
                ]
            },
            {
                id: 'northOstrobothnia',
                name: 'North Ostrobothnia',
                shape: 'M1249.54 1432.42L1255.1 1413.66L1244.43 1395.98L1272.65 1377.19L1291.83 1375.39L1283.12 1314.19L1253.6 1230.01L1228.84 1193.52L1210.13 1143.13L1164.9 1148.94L1090.66 1131.53L1091.15 1148.17L1076.17 1154.1L1071.28 1172.43L1083.92 1199.62L1102.37 1207.39L1097.83 1238.66L1088.46 1240.12L1088.15 1257.45L1100.68 1266.58L1101.03 1283.37L1095.57 1287.83L1077.46 1282.68L1059.12 1291.56L1073.86 1313.76L1072.73 1332.78L1042.93 1345.8L975.501 1335.13L961.651 1300.76L951.357 1305.63L937.801 1299.47L895.343 1368.64L864.205 1379.25L772.361 1371.3L768.86 1341.32L722.393 1370.6L669.039 1367.55L665.853 1382.3L644.581 1393.35L630.23 1407.98C630.843 1408.62 631.459 1409.25 632.072 1409.88L632.64 1422.94L639.594 1422.97L644.24 1418.69L662.915 1451.92L661.902 1464.34L653.738 1473.01L653.764 1487.62L647.473 1495.31L652.912 1505.34L652.815 1536.48L644.137 1548.11L648.52 1557.66L660.919 1564.82L666.206 1574.5L669.349 1595.25L678.755 1604.84L677.978 1610.53L671.576 1610.22L657.18 1598.58L643.79 1597.42L641.437 1604.1L642.594 1612.63L662.115 1632.22L666.044 1643.99L660.91 1648.64L651.942 1647.86L650.171 1637.38L630.579 1626.01L612.277 1625.86L602.813 1633.23L581.394 1633.45L574.23 1639.82L570.003 1647.48L557.649 1648.91L552.525 1675.4L533.403 1688.69L523.237 1731.71L510.605 1741.47L509.722 1748.45L492.3 1759.99L472.087 1781.66L469.072 1788.83L461.391 1801.43L461.161 1816.12L455.044 1819.43L447.532 1814.45L438.57 1828.01L431.145 1833.99L423.723 1845.3L481.652 1883.81L491.075 1921.44L501.864 1927.05L506.846 1948L521.601 1953.81L538.046 2003.25L599.903 2078.58L617.389 2076.27L623.866 2036.03L638.587 2029.92L685.253 2061.93L708.839 2062L718.326 2069.92L727.238 2088.73L758.092 2088.51L774.228 2042.86L782.499 2037.9L775.048 1962.3L824.785 1916.34L859.182 1904.76L848.346 1891.13L848.354 1821.09L832.757 1810.71L821.034 1812.34L806.549 1799.65L808.824 1785.47L801.428 1769.09L788.21 1760.42L813.266 1734.86L826.477 1730.98L831.398 1715.06L859.756 1701.23L869.765 1672.2L895.652 1659.86L896.492 1652.47L926.933 1659.48L932.648 1644.1L930.183 1603.24L913.053 1588.91L925.747 1568.07L953.608 1568.19L968.106 1557.38L984.246 1559.48L998.446 1569.29L1004.55 1531.77L1019.43 1522.71L1091.7 1509.74L1095.06 1476.19L1135.96 1456.89L1144.64 1463.99L1159.41 1459.54L1171.85 1432.9L1177.88 1437.9L1212.83 1439.55L1249.54 1432.42Z',
                center: {
                    x: 200,
                    y: 200
                },
                cities: [
                    {
                        x: 700,
                        y: 1600,
                        id: "oulu",
                        name: "Oulu"
                    }
                ]
            },
        ],
    }),
    mutations: {},
    actions: {}
}

export const citiesModule = {
    state: () => ({}),
    mutations: {},
    actions: {}
}

export const tagsModule = {
    state: () => ({
        topics: null, // list of position topics
    }),
    mutations: {
        mutateTopics(state, topics) {
            state.topics = topics;
        },
    },
    actions: {
        // COMMITS
        commitTopics: ({ commit }, context) => {
            commit('mutateTopics', context);
        },

        // API CALLS
        dispatchTopics: ({ dispatch }) => new Promise((resolve, reject) => {
            api.getTopics().then((response) => {
                const data = Object.values(response.data.topics).map(topics => topics.label);
                dispatch('commitTopics', data);
                resolve();
            }).catch((error) => {
                reject(error);
            });
        }),
    }
}

export const reasonsModule = {
    state: () => ({
        reasonsToReport: null,
        reasonsToHide: null,
    }),
    mutations: {
        mutateReasonsToHide(state, reasons) {
            state.reasonsToHide = reasons;
        },
        mutateReasonsToReport(state, reasons) {
            state.reasonsToReport = reasons;
        },
    },
    actions: {
        // COMMMITS
        commitReasonsToHide: ({ commit }, context) => {
            commit('mutateReasonsToHide', context);
        },
        commitReasonsToReport: ({ commit }, context) => {
            commit('mutateReasonsToReport', context);
        },

        // API CALLS
        dispatchReport: ({ state }, { jobId, report }) => new Promise((resolve, reject) => {
            api.postReportJob(jobId, report).then((response) => {
                const { data } = response;
                console.log(response);
                resolve();
            }).catch((error) => {
                reject(error);
            });
        }),
        dispatchReasonsToHide: ({ dispatch }) => new Promise((resolve, reject) => {
            api.getReasonsToHide().then((response) => {
                const data = response.data.reasons;
                dispatch('commitReasonsToHide', data);
                resolve();
            }).catch((error) => {
                reject(error);
            });
        }),
        dispatchReasonsToReport: ({ dispatch }) => new Promise((resolve, reject) => {
            api.getReasonsToReport().then((response) => {
                const data = response.data.reasons;
                console.log(data);
                dispatch('commitReasonsToReport', data);
                resolve();
            }).catch((error) => {
                reject(error);
            });
        }),
    }
}

export const jobsModule = {
    state: () => ({
        apiData: initialLoad, // Updated on app load, will contain the whole data from API
        searchResults: initialLoad, // This is updated when a search is done
    }),
    mutations: {
        mutateApiData(state, data) {
            state.apiData = data;
            state.searchResults = data;
            state.searchResults.forEach((element) => {
                Vue.set(element, 'match', true);
                Vue.set(element, 'sortKey', /*element.reviewed + */element.firstSeen + (!element.imageURL));
            });
        },
        mutateSearchResults(state, filters) {
            // First check if there are search terms at all
            if (!filters.area && !filters.keywords) {
                state.searchResults.forEach((element) => {
                    Vue.set(element, 'match', true);
                });
            } else {
                if (state.searchResults !== null) {
                    state.searchResults.forEach((element) => {
                        // Check each entry in array for results, and set the match status false/true:
                        const { title, organization } = element;
                        const { city } = element.location;
                        const { area } = element.location;
                        const { categories, topics } = element.clustering ? element.clustering : { categories: '', topics: '' };
                        const titleMatch = (filters.keywords) ? RegExp(filters.keywords, 'gi').test(title) : false;
                        const organizationMatch = (filters.keywords) ? RegExp(filters.keywords, 'gi').test(organization) : false;
                        const areaMatch = (filters.area) ? RegExp(filters.area, 'gi').test(area) : false;
                        const cityMatch = (filters.area) ? RegExp(filters.area, 'gi').test(city) : false;

                        const categoryMatch = (filters.keywords && categories.length) ? categories.reduce((found, category) => found || RegExp(filters.keywords, 'gi').test(category.name), false) : false;
                        const topicMatch = (filters.keywords && topics.length) ? topics.reduce((found, topic) => found || RegExp(filters.keywords, 'gi').test(topic.name), false) : false;

                        const keywordMatch = !!((categoryMatch || topicMatch || titleMatch || organizationMatch));
                        if (filters.keywords && !filters.area) {
                            // No area specified, match all keyword results
                            // eslint-disable-next-line no-unused-expressions
                            (keywordMatch) ? Vue.set(element, 'match', true) : Vue.set(element, 'match', false);
                        } else if (!filters.keywords && filters.area) {
                            // Area specified, but no keyword. Match all area results
                            // eslint-disable-next-line no-unused-expressions
                            (areaMatch || cityMatch) ? Vue.set(element, 'match', true) : Vue.set(element, 'match', false);
                        } else if (filters.keywords && filters.area) {
                            // Keywords and area specified, match only where both apply
                            // eslint-disable-next-line no-unused-expressions
                            ((keywordMatch && cityMatch) || (areaMatch && keywordMatch)) ? Vue.set(element, 'match', true) : Vue.set(element, 'match', false);
                        }
                    });
                }
            }
        },
    },
    actions: {
        // COMMITS
        commitApiData: ({ commit }, context) => {
            commit('mutateApiData', context);
        },
        commitSearchResults: ({ commit }, context) => {
            commit('mutateSearchResults', context);
        },

        // API CALLS
        dispatchGetJobsAdmin: ({ dispatch, state }) => new Promise((resolve, reject) => {
            api.getJobsAdmin(state.JWT).then((response) => {
                const { data } = response;
                console.log(response);
                dispatch('commitApiData', data.jobs);
                resolve();
            }).catch((error) => {
                reject(error);
            });
        }),
        dispatchGetJobs: ({ dispatch }) => new Promise((resolve, reject) => {
            api.getJobs().then((response) => {
                const { data } = response;
                console.log(response);
                dispatch('commitApiData', data.jobs);
                resolve();
            }).catch((error) => {
                reject(error);
            });
        }),
        dispatchPutJob: ({ state }, { jobId, jobData }) => new Promise((resolve, reject) => {
            api.putJob(jobId, jobData, state.JWT).then((response) => {
                const { data } = response;
                console.log(response);
                resolve();
            }).catch((error) => {
                reject(error);
            });
        }),
        dispatchPostJob: ({ state }, { jobData }) => new Promise((resolve, reject) => {
            api.postJob(jobData, state.JWT).then((response) => {
                const { data } = response;
                console.log(response);
                resolve();
            }).catch((error) => {
                reject(error);
            });
        }),

    }
}

export const campaignsModule = {
    state: () => ({
        campaigns: [],
    }),
    mutations: {
        mutateCampaigns(state, campaigns) {
            state.campaigns = campaigns;
        },
    },
    actions: {
        // COMMITS
        commitCampaigns: ({ commit }, context) => {
            commit('mutateCampaigns', context);
        },

        // API CALLS
        dispatchGetCampaigns: ({ dispatch }) => new Promise((resolve, reject) => {
            api.getCampaigns().then((response) => {
                const { data } = response;
                console.log(response);
                dispatch('commitCampaigns', data.campaigns);
                resolve();
            }).catch((error) => {
                reject(error);
            });
        }),
        dispatchPostCampaign: ({ state }, { campaignData }) => new Promise((resolve, reject) => {
            api.postCampaign(campaignData, state.JWT).then((response) => {
                const { data } = response;
                console.log(response);
                resolve();
            }).catch((error) => {
                reject(error);
            });
        }),

    }
}

export const employersModule = {
    state: () => ({
        employers: []
    }),
    mutations: {
        mutateEmployers(state, employers) {
            state.employers = employers;
        },
    },
    actions: {
        // COMMITS
        commitEmployers: ({ commit }, context) => {
            commit('mutateEmployers', context);
        },

        // API CALLS
        dispatchGetEmployers: ({ dispatch }) => new Promise((resolve, reject) => {
            api.getEmployers().then((response) => {
                const { data } = response;
                console.log("Employers", response);
                dispatch('commitEmployers', data);
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        }),

        // TODO: GET employers (admin)

        // TODO: POST employer (admin)

        // TODO: PUT employer (admin)
        
    }
}

export const pagesModule = {
    state: () => ({
        pages: [],
    }),
    mutations: {
        mutatePages(state, pages) {
            state.pages = pages;
        },
    },
    actions: {
        // COMMITS
        commitPages: ({ commit }, context) => {
            commit('mutatePages', context);
        },

        // API CALLS
        dispatchGetPages: ({ dispatch }) => new Promise((resolve, reject) => {
            api.getPages().then((response) => {
                const { data } = response;
                console.log(response);
                dispatch('commitPages', data.pages);
                resolve();
            }).catch((error) => {
                reject(error);
            });
        }),
    }
}

export const usersModule = {
    state: () => ({
        users: [],
    }),
    mutations: {
        mutateUsers(state, users) {
            state.users = users;
        },
    },
    actions: {
        // COMMITS
        commitUsers: ({ commit }, context) => {
            commit('mutateUsers', context);
        },

        // API CALLS
        dispatchGetUsers: ({ dispatch }) => new Promise((resolve, reject) => {
            api.getUsers().then((response) => {
                const { data } = response;
                console.log(response);
                dispatch('commitUsers', data.users);
                resolve();
            }).catch((error) => {
                reject(error);
            });
        }),
    }
}

// Local storage
export const localModule = {
    state: () => ({
        mapVisibility: null,
        searchTerms: {
            area: '',
            keywords: '',
        }, // Takes object with keys 'keyword' and 'area',
        userFavorites: [],
        selectedPosition: null, // Taked the position info as an object
    }),
    mutations: {
        mutateSearchTerms(state, filters) {
            state.searchTerms = filters;
        },
        mutateSelectedPosition(state, item) {
            state.selectedPosition = item;
        },
        mutateMapVisibility(state, val) {
            state.mapVisibility = val;
        },
        mutateFavorites(state, data) {
            console.log(data);
            switch (data.action) {
                case 'add':
                    if (state.userFavorites.findIndex(item => item.id == data.jobId) > -1) return;

                    let favorite = state.searchResults.find(item => item.id == data.jobId);
                    state.userFavorites.push(favorite);
                    break;
                case 'remove':
                    let index = state.userFavorites.findIndex(item => item.id == data.jobId);
                    state.userFavorites.splice(index, 1);
                    break;
                case 'clear':
                    state.userFavorites = [];
                    break;
            }
            // Update localStorage and reset TTL
            console.log('Update favorites in local storage');
            let payload = {
                expiry: new Date().getTime() + 1000 * 60 * 60 * 24,
                items: state.userFavorites
            }
            localStorage.favorites = JSON.stringify(payload);

        },
    },
    actions: {
        commitMapVisibility: ({ commit }, context) => {
            commit('mutateMapVisibility', context);
        },
        commitSearchTerms: ({ commit }, context) => {
            commit('mutateSearchTerms', context);
        },
        commitSelectedPosition: ({ commit }, context) => {
            commit('mutateSelectedPosition', context);
        },
        commitFavorite: ({ commit }, context) => {
            commit('mutateFavorites', context);
        },

        fetchFavorites() {
            console.log('Fetch favorites from local storage');
            if (localStorage.favorites) {
                let data = JSON.parse(localStorage.favorites);
                console.log(data.expiry - new Date().getTime());
                if (data.expiry && (data.expiry > new Date().getTime())) {
                    this.state.userFavorites = data.items;
                }
                else {
                    this.state.userFavorites = [];
                }
            }
        },
    }
}